class Navbar {
  constructor() {
    this.navbar = document.getElementById('navbar')
    this.menuToggle = document.getElementById('menu-toggle')
    this.mobileMenu = document.getElementById('mobile-menu')
    this.currentPage = document.body.dataset.page || ''
    this.init()
  }

  init() {
    this.setActiveLink()
    if (this.menuToggle) {
      this.menuToggle.addEventListener('click', () => this.toggleMobile())
    }
    document.querySelectorAll('#mobile-menu a').forEach(link => {
      link.addEventListener('click', () => this.closeMobile())
    })
  }

  setActiveLink() {
    document.querySelectorAll('.nav-link, .nav-link-mobile').forEach(link => {
      if (link.dataset.page === this.currentPage) {
        link.classList.add('active')
      }
    })
  }

  toggleMobile() {
    this.mobileMenu.classList.toggle('hidden')
  }

  closeMobile() {
    this.mobileMenu.classList.add('hidden')
  }
}

export default Navbar